export default class Utils {


static getURL(){
  // KAK vždy REMovat nepotřebné!    
  // return new URL('server/srv-res.php', 'http://localhost:3000/augustin/adoration/');            
  return new URL('server/srv-res.php', 'http://adoration.augustinbrno.cz/');            
      }
  }
